import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "LOYALTY_GET_LEDGER_CONTEXT_SUCCESS":
    case "LOYALTY_GET_LEDGER_CONTEXT_FAILURE":
      return false;

    case "LOYALTY_GET_LEDGER_CONTEXT_REQUEST":
      return true;

    default:
      return state;
  }
}
